<div class="video-wrapper">
  <video #videoRef  [src]="currentImage.modal.extUrl" autoplay class="video" controls loop playsinline></video>
</div>
